export default "__VITE_ASSET__BjH7sEjU__"